import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { HlmBtnDirective, HlmIconComponent } from '../../../../ui';
import { DomainRow } from './domain-list.component';

export interface DomainGridContext {
  canWrite: () => boolean;
  confirmDelete: (row: DomainRow) => void;
}

/** Row actions for the global Domains grid. Editing happens by clicking the
 *  row (same affordance as the Brands list), so only Delete lives here. */
@Component({
  selector: 'cmt-domain-action-cell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HlmBtnDirective, HlmIconComponent],
  template: `
    <div class="flex items-center gap-1.5 py-0.5">
      <button
        hlmBtn
        variant="destructive"
        size="sm"
        type="button"
        class="h-7 px-2.5"
        [disabled]="!ctx?.canWrite()"
        (click)="onDelete($event)"
        aria-label="Delete domain"
      >
        <hlm-icon name="lucideTrash2" size="0.9rem" />
        Delete
      </button>
    </div>
  `,
})
export class DomainActionCellComponent implements ICellRendererAngularComp {
  protected ctx: DomainGridContext | null = null;
  private row: DomainRow | null = null;

  agInit(params: ICellRendererParams<DomainRow>): void {
    this.row = params.data ?? null;
    this.ctx = params.context as DomainGridContext;
  }

  refresh(params: ICellRendererParams<DomainRow>): boolean {
    this.row = params.data ?? null;
    this.ctx = params.context as DomainGridContext;
    return true;
  }

  protected onDelete(event: MouseEvent): void {
    event.stopPropagation();
    if (this.row && this.ctx) this.ctx.confirmDelete(this.row);
  }
}
